export default {
  recommendedBoards: (state: any) => state.recommendedBoards,
  recommendedBoardSections: (state: any) => state.recommendedBoardSections,
  listPerformance: (state: any) => (listId: number) => {
    return state.listPerformance[listId];
  },
};
